import noImage from '@/assets/no-image-available.svg'

export function useDefaultImage(event) {
  const img = event.target;

  img.onerror = null
  img.src =  noImage;
}